/* eslint-disable */

import "./NewHeader.scss";

import moment from "moment";
import { useEffect, useState } from "react";
import { FaRegEnvelopeOpen } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

import CardCMCS from "./components/CardCMCS";
import CardStudent from "./components/CardStudent";
import CardTeacher from "./components/CardTeacher";
import Background from "../../assets/images/bg-header.svg";
import { endLoading, initLoading } from "../../store/slices/generics.slice";
import { getClassesRating, getClassesRatingAVGByTeacher, getStatusCollab } from "../../store/middleware";

const Header = ({
  icon,
  title,
  rightIcon = null,
  leftButton = null,
  rightButton = null,
  typeIcon = "default",
  initLoadingBoolean = true,
  onClickRightIcon = () => {},
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const { classesForRating } = useSelector((state) => state.genericReducer);

  const isStudent = user?.role === "student";
  const isTeacher = user?.role === "teacher";
  const isCompanyManager = user?.role === "companyManager";
  const isCustomerService = user?.role === "customerService";

  const [ratingPending, setRatingPending] = useState(0);
  const [statusCollab, setStatusCollab] = useState({});
  const [ratingPendingAVG, setRatingPendingAVG] = useState(0);

  const getData = async () => {
    initLoadingBoolean && (await dispatch(initLoading()));

    if (isStudent) {
      await dispatch(
        getClassesRating({
          planId: "",
          status: "",
          teacher: "",
          student: "",
          levelId: "",
          pageSize: 20,
          pageNumber: 1,
          studentLevel: "",
          lingoLanguageId: "",
          ratingCriteriaId: "",
          classRatingStatus: "",
          ratingCriteriaGrade: "",
          studentId: user?.role === "student" ? user?.studentId : "",
          endAt: user?.role === "student" ? "" : moment().format("YYYY-MM-DD"),
          startAt: user?.role === "student" ? "" : moment().subtract(30, "days").format("YYYY-MM-DD"),
        }),
      ).then((res) => {
        setRatingPending(
          res?.items?.filter(
            (item) =>
              (!item?.teacherRating || item?.teacherRating.status === "pending") &&
              item?.status === "done" &&
              moment(item?.originalScheduledDateTime).format("YYYY-MM-DD") > moment("2023-10-19").format("YYYY-MM-DD"),
          ).length,
        );
      });
    }

    if (isTeacher) {
      await dispatch(getClassesRatingAVGByTeacher(user?.teacherId))
        .then((res) => {
          setRatingPendingAVG(
            res[0]?.averageRating === null ? Number(res[0]?.teacher?.averageRating) : Number(res[0]?.averageRating),
          );
        })
        .catch((err) => console.log("ERROR getClassesRating ", err));
    }

    if (isCompanyManager || isCustomerService) {
      const response = await dispatch(getStatusCollab());
      setStatusCollab(response);
    }

    initLoadingBoolean && (await dispatch(endLoading()));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [classesForRating]);

  return (
    <header className="new-header" style={user?.role !== "student" ? { backgroundImage: `url(${Background})` } : {}}>
      {isTeacher && <CardTeacher ratingPendingAVG={ratingPendingAVG} />}
      {isStudent && <CardStudent ratingPending={ratingPending} />}
      {(isCompanyManager || isCustomerService) && <CardCMCS statusCollab={statusCollab} />}

      <h1 className="alignItems">
        <span>
          {typeIcon === "default" ? <img src={icon} alt={title} /> : icon}
          {title}
          {leftButton ? leftButton : <></>}
        </span>

        {rightIcon ? <FaRegEnvelopeOpen onClick={onClickRightIcon} /> : <></>}
        {rightButton ? rightButton : <></>}
      </h1>
    </header>
  );
};

export default Header;
